"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InProgress = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const Base_1 = require("../Base");
const animStyle = "@keyframes ←{0%{transform:translateX(0)}67%{transform:translateX(0)}100%{transform:translateX(-6px)}}" +
    "@media(prefers-reduced-motion:no-preference){#…{animation:← 3s infinite}}";
const InProgress = ({ colour = "currentcolor", size = 16, title }) => (react_1.default.createElement(Base_1.Base, { size: size, title: title, smooth: true },
    react_1.default.createElement("style", null, animStyle),
    react_1.default.createElement("path", { id: "\u2026", d: "M1 8h24", stroke: colour, strokeWidth: "3", strokeDasharray: "3" })));
exports.InProgress = InProgress;
//# sourceMappingURL=InProgress.js.map